/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './DeleteCustomGroupModal.scss';

import React from 'react';
import { connect } from 'react-redux';
import { updateCustomerPreferences } from 'services/Rest';
import { getActiveCustomAccountGroup } from 'state/preferences/PreferencesReducer';
import SaveLoadingButtonWithPermissions from 'components/shared/LoadingButton/SaveLoadingButtonWithPermissions';
import Store from 'state/Store';
import { errorCustomAccountGroups } from 'state/preferences/PreferencesActions';

class DeleteCustomGroup extends React.Component {
  deleteGroup = () => {
    const { activeCustomAccountGroup, close } = this.props;
    const deleteCustomGroupPayload = {
      customAccountGroups: [
        {
          groupName: activeCustomAccountGroup.groupName,
          groupId: activeCustomAccountGroup.groupId,
          accountDescriptors: activeCustomAccountGroup.accountDescriptors,
          disposition: {
            action: 'remove'
          }
        }
      ]
    };
    updateCustomerPreferences(deleteCustomGroupPayload, close, () => {
      Store.dispatch(errorCustomAccountGroups());
    });
  };

  render() {
    const { activeCustomAccountGroup, close } = this.props;
    return (
      <div className="custom-account-group-modal-container">
        <div className="custom-account-group-modal-body">
          <p>
            This will permanently delete &apos;
            {activeCustomAccountGroup && activeCustomAccountGroup.groupName}
            &apos;
          </p>
        </div>
        <div className="create-custom-group-submit-container">
          <button className="customize-accounts-cancel-button" onClick={close}>
            Cancel
          </button>
          <SaveLoadingButtonWithPermissions
            className="customize-accounts-save-button"
            onClick={this.deleteGroup}
            requestStatusKey="updateCustomerPreferences"
            shouldDisable>
            Delete
          </SaveLoadingButtonWithPermissions>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activeCustomAccountGroup: getActiveCustomAccountGroup(
    state.customerPreferences.customAccountGroups
  )
});

export default connect(mapStateToProps)(DeleteCustomGroup);
